import * as React from 'react';
import { SVGProps } from 'react';
export const CabinetWhiteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M13 1.25H4.5A2.25 2.25 0 0 0 2.25 3.5V14a.75.75 0 0 0 .75.75h9a.75.75 0 1 0 0-1.5H3.75V13a.75.75 0 0 1 .75-.75H13a.75.75 0 0 0 .75-.75V2a.75.75 0 0 0-.75-.75Zm-5.5 1.5h2.25v3.688l-.657-.526a.75.75 0 0 0-.937 0l-.656.526V2.75Zm4.75 8H4.5c-.256 0-.51.043-.75.129V3.5a.75.75 0 0 1 .75-.75H6V8a.75.75 0 0 0 1.219.586L8.624 7.46l1.407 1.125A.75.75 0 0 0 11.25 8V2.75h1v8Z"
    />
  </svg>
);
